import { CenteredSpinner } from "@adsk/acc-issues-common/components/primitive/CenteredSpinner";
import React from "react";

export const defaultLoader = () => <CenteredSpinner />;
